export const PlaceholderImage = ({ label = "Official visual coming soon", className = "", letter = "L" }) => (
    <div className={`relative pattern-zigzag bg-lakou-raise flex flex-col items-center justify-center ${className}`}>
        <span className="font-display font-black text-6xl text-stroke-gold opacity-60">{letter}</span>
        <span className="mt-3 font-mono2 text-[9px] uppercase tracking-[0.3em] text-lakou-sand px-4 text-center">{label}</span>
    </div>
);
